<template>
  <div>
    <v-app-bar app clipped-right color="blue-grey" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <font-awesome-icon icon="bars"></font-awesome-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>Alcor</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="logout">
        <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
      </v-btn>
    </v-app-bar>
    <sidebar v-model="drawer"></sidebar>
    <v-container id="container" class="fill-height" fluid>
      <v-slide-x-transition mode="out-in">
        <router-view> </router-view>
      </v-slide-x-transition>
    </v-container>
  </div>
</template>
<script>
import AdministrationSidebar from "./AdministrationSidebar.vue";
import { LOGOUT_USER } from "../../store/actions.js";
import { RENEW_TOKEN } from "../../store/mutations.js";
import HttpStatus from "http-status";
import {
  attachResponseInterceptor,
  detachResponseInterceptor
} from "../../../api/httpClient.js";
import { checkSession } from "../../../api/session.api.js";

export default {
  name: "AdministrationLayout",
  components: {
    Sidebar: AdministrationSidebar
  },
  data() {
    return {
      drawer: false
    };
  },
  async beforeRouteEnter(to, from, next) {
    if (from.path === "/") {
      try {
        await checkSession();
        next();
      } catch (e) {
        next(vm => {
          vm.logout();
        });
      }
    } else {
      next();
    }
  },
  created() {
    const interceptorIdentifier = attachResponseInterceptor(
      (response, token) => {
        if (token) {
          this.$store.commit(RENEW_TOKEN, { token: token });
        }
      },
      error => {
        if (error.response) {
          const { status } = error.response;

          if (status === HttpStatus.NOT_FOUND) {
            console.warn(
              `API Endpoint with url: '${error.config.url}' not found.`
            );
          } else if (status === HttpStatus.BAD_REQUEST) {
            console.error(error);
          } else if (status === HttpStatus.UNAUTHORIZED) {
            this.logout();
          } else if (status === HttpStatus.INTERNAL_SERVER_ERROR) {
            console.error(error);
          }
        }
        return Promise.reject(error);
      }
    );
    this.$once("destroyed", () => {
      detachResponseInterceptor(interceptorIdentifier);
    });
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT_USER).then(() => {
        this.$router.push({ name: this.$routes.session.createRoute.name });
      });
    }
  },
  destroyed() {
    this.$emit("destroyed");
  }
};
</script>

<style scoped></style>
